import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const reishauerCustomerGroup = 'reishauer';
export const customerGroup = reishauerCustomerGroup;

export const reishauerNachtschichtReadableId = 'Reishauer_Nachtschicht';
export const reishauerMeetingraumReadableId = 'Reishauer_Vendomat';

const supportEmail = {
	reishauer: 'reishauer@smoothr.de',
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyDAdrZ5vG1_A-5rChcnhh6UQjfhX1OI9QE',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	...apiEnvironment,
	countryList: ['en'],
	gaId: '',
	hasRecommendations: true,
	apiUrl: 'https://reishauer.smoothr.de/',
	location: '',
	deactivateDelivery: false,
	enableCashPayment: true,
	allowNavigationToWorldline: false,
	urlQrCode: 'smoothr://',
	reishauerNachtschichtReadableId: reishauerNachtschichtReadableId,
	reishauerMeetingraumReadableId: reishauerMeetingraumReadableId
};
